module.exports = __webpack_public_path__ + "img/La_Mer_Logo_White.97190ed3.png";